function uploadNewFile(type, name) {
  var id = uuidv4();
  var callback = function (data) {
    formUserInput = true;
    createFileInput('add', 'device', type, name, data, id);
  };
  var button = addUploadButton(type, name, id, null, callback);
  button.trigger('click');
}

function uploadAndReplaceFile(type, name, id, dbid) {
  var wrapper = $('.file-input__wrapper[data-id="' + id + '"]');
  if (wrapper[0].hasAttribute('data-remove')) {
    return;
  }
  var callback = function (data) {
    formUserInput = true;
    createFileInput('replace', 'device', type, name, data, id);
  };
  var button = addUploadButton(type, name, id, dbid, callback);
  button.trigger('click');
}

function mediathekNewFile(type, name) {
  var id = uuidv4();
  app.selectMediaCallback = function (data) {
    formUserInput = true;
    createFileInput('add', 'mediathek', type, name, data, id);
  };
  openMediaLibrary(type, true);
}

function mediathekReplaceFile(type, name, id, dbid) {
  var wrapper = $('.file-input__wrapper[data-id="' + id + '"]');
  if (wrapper[0].hasAttribute('data-remove')) {
    return;
  }
  app.selectMediaCallback = function (data) {
    formUserInput = true;
    data.replaceId = dbid;
    createFileInput('replace', 'mediathek', type, name, data, id);
  };
  openMediaLibrary(type, true);
}

// Add an upload button

function addUploadButton(type, name, id, dbid, callback) {
  var buttonEl = $('<input class="file-input__button" type="file"/>');
  buttonEl.attr('data-id', id);
  if (type == 'image') {
    buttonEl.attr('accept', '.jpg,.jpeg,.png,.svg');
  }
  buttonEl.on('change', function () {
    var data = {
      id: dbid,
      type: type,
      name: name,
      file: $(this)[0].files[0],
      altTitleEnabled: false,
      values: {
        title: '',
        altTitle: '',
        author: ''
      }
    };
    callback && callback(data);
  });
  var currentButton = $('.file-input__button[data-id="' + id + '"]');
  if (currentButton.length) {
    currentButton.replaceWith(buttonEl);
  } else {
    $(
      '.input__wrapper[data-form-input="' +
        name +
        '"] .file-input-buttons__wrapper'
    ).append(buttonEl);
  }
  return buttonEl;
}

// Add file button

function uploadFile(type, name) {
  var id = 'file__' + type + '__' + name;
  var callback = function (data) {
    var wrapper = $('.input__wrapper[data-form-input="' + data.name + '"]');
    wrapper[0].removeAttribute('data-error');
    wrapper.attr('data-has-value', '1');
    wrapper.find('.input__error').html('');
    wrapper
      .find('.file-upload__text')
      .html(data.file.name)
      .addClass('file-upload__text--active');
    var previewEl = wrapper.find('.file-upload__preview');

    switch (type) {
      case 'image':
        var previewItemEl = $(
          '<img class="file-input__preview-image" alt=""/>'
        );

        var reader = new FileReader();
        reader.onload = function (event) {
          var img = document.createElement('img');
          img.src = event.target.result;

          img.onload = function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');

            var MAX_WIDTH = 42;
            var MAX_HEIGHT = 42;

            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height = height * (MAX_WIDTH / width);
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width = width * (MAX_HEIGHT / height);
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            var dataurl = canvas.toDataURL(data.file.type);
            previewItemEl.attr('src', dataurl);
          };
        };
        reader.readAsDataURL(data.file);

        break;
      case 'document':
        var previewItemEl = $('<img alt=""/>').attr(
          'src',
          getFileExtensionImage(data.uri ? data.uri : data.file.name)
        );
        break;
    }
    previewEl
      .html('')
      .append(previewItemEl)
      .addClass('file-upload__preview--active');
  };
  var button = addUploadButton(type, name, id, null, callback);
  button.trigger('click');
}
